import {
	ButtonSubmit,
	ColourStateSolid,
	FlexGap,
	Modal,
	ModalType,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import { SearchMailType } from '../Search/Controls/SearchMailType';
import { SearchMailTerm } from '../Search/Controls/SearchMailTerm';
import { SearchMailNames } from '../Search/Controls/SearchMailNames';
import { SearchMailStatus } from '../Search/Controls/SearchMailStatus';
import { SearchMailScanned } from '../Search/Controls/SearchMailScanned';
import { SearchMailTags } from '../Search/Controls/SearchMailTags';
import { SearchMailDateRange } from '../Search/Controls/SearchMailDateRange';

interface MailboxFilterModalType extends ModalType {
	searchParams: URLSearchParams;
	searchReset: boolean;
	UpdateUrlSearchParams: (newParams: URLSearchParams) => void;
}

function FilterMailboxModal(props: MailboxFilterModalType) {
	const { t } = useTranslation();

	const formMethods = useForm({
		mode: 'onChange',
	});

	const HandleSubmit = (e: any) => {
		const newUrlParams: any = {};
		Object.keys(e).forEach((key) => {
			if (e[key] !== '' && e[key] !== undefined && e[key] !== null) {
				newUrlParams[key] = e[key];
			}
		});

		props.UpdateUrlSearchParams(newUrlParams);
		props.closeCallback();
	};

	useEffect(() => {
		formMethods.setValue('folderId', props.searchParams?.get('folderId') || '');
		formMethods.setValue('startDate', props.searchParams?.get('startDate') || '');
		formMethods.setValue('endDate', props.searchParams?.get('endDate') || '');
		formMethods.setValue('mailType', props.searchParams?.get('mailType') || '');
		formMethods.setValue('scanned', props.searchParams?.get('scanned') || '');
		formMethods.setValue('mailTagIds', props.searchParams?.get('mailTagIds') || '');
		formMethods.setValue('clientFolderIds', props.searchParams?.get('clientFolderIds') || '');
		formMethods.setValue('includeFolderAssigned', props.searchParams?.get('includeFolderAssigned') || '');
		formMethods.setValue('incomingRecipientNameIds', props.searchParams?.get('incomingRecipientNameIds') || '');
		formMethods.setValue('term', props.searchParams?.get('term') || '');
		formMethods.setValue('unreadStatus', props.searchParams?.get('unreadStatus') || '');
		formMethods.setValue('mailId', props.searchParams?.get('mailId') || '');
		formMethods.setValue('folderSlug', props.searchParams?.get('folderSlug') || '');
	}, [props.searchReset, props.searchParams]);

	return (
		<Modal title={t('mailboxes.filter.title')} isOpen={props.isOpen} closeCallback={props.closeCallback}>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(HandleSubmit)}>
					<fieldset>
						<StackVertical gap={FlexGap.Medium}>
							<div className='row'>
								<div className='col-xs-12 col-md-6'>
									<StackVertical gap={FlexGap.Medium}>
										<SearchMailType formMethods={formMethods} searchParams={props.searchParams} />
										<SearchMailTerm formMethods={formMethods} searchParams={props.searchParams} />
										<SearchMailNames formMethods={formMethods} searchParams={props.searchParams} />
										<SearchMailStatus formMethods={formMethods} searchParams={props.searchParams} />
									</StackVertical>
								</div>
								<div className='col-xs-12 col-md-6'>
									<StackVertical gap={FlexGap.Medium}>
										<SearchMailScanned
											formMethods={formMethods}
											searchParams={props.searchParams}
										/>
										<SearchMailTags formMethods={formMethods} searchParams={props.searchParams} />
										<SearchMailDateRange
											formMethods={formMethods}
											searchParams={props.searchParams}
										/>
									</StackVertical>
								</div>
							</div>

							<ButtonSubmit
								fullWidth
								colour={ColourStateSolid.Primary}
								title={t('mailboxes.filter.actions.save')}
							/>
						</StackVertical>
					</fieldset>
				</form>
			</FormProvider>
		</Modal>
	);
}

export { FilterMailboxModal };
